// extracted by mini-css-extract-plugin
module.exports = {"description":"leave-organization-modal_description__2ty7F","submit":"leave-organization-modal_submit__3afP8","orgName":"leave-organization-modal_orgName__1sNqf"};